import React, { useEffect, useCallback, useState } from 'react'
import styled from 'styled-components'
import { Base64 } from 'js-base64'

import { Button } from 'semantic-ui-react'
import SurveyPreview from 'components/SurveyPreview'

/**
 *
 * @param {object} props
 * @param {string} props.previewStyle
 */
export default function BrandWebEmbedSurveyLivePreview({ previewStyle }) {
  const [previewMode, setPreviewMode] = useState('desktop')
  const [revisonNumber, setRevisonNumber] = useState(1)
  const [encodedStyle, setEncodedStyle] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const previewURL = `${window.location.origin}/brands/web-embed-preview/`

  function handleReloadPreview(event) {
    event.preventDefault()
    setRevisonNumber((revisonNumber) => revisonNumber + 1)
  }
  /**
   *
   * @param {string} message
   */
  const sendMessageToIframe = useCallback(function postMessage(previewStyle) {
    if (previewStyle) {
      const message = JSON.stringify(previewStyle)
      const iframe = document.documentElement.querySelector('iframe')
      iframe.contentWindow.postMessage(
        {
          type: 'set_content',
          content: message,
        },
        '*'
      )
    }
  }, [])

  function handleIframeLoad() {
    sendMessageToIframe(previewStyle)
  }

  useEffect(() => {
    if (previewStyle) {
      sendMessageToIframe(previewStyle)
    }
  }, [previewStyle, sendMessageToIframe])

  useEffect(() => {
    if (isLoading) {
      // set encodedStyle one-time when initial component
      const encodedStyle = Base64.encode(previewStyle)
      setEncodedStyle(encodedStyle)
      setIsLoading(false)
    }
  }, [isLoading, previewStyle])

  if (isLoading) {
    return null
  } else {
    return (
      <React.Fragment>
        <SurveyPreview onChange={setPreviewMode} showDeviceSwitcher={true}>
          <Wrapper className={previewMode}>
            <iframe
              className="scale-frame"
              frameBorder={0}
              onLoad={handleIframeLoad}
              src={`${previewURL}?revison=${revisonNumber}&init=${encodedStyle}`}
            />
          </Wrapper>
        </SurveyPreview>
        <div className="text-center mt-2">
          <Button basic onClick={handleReloadPreview}>
            Reset survey to first question
          </Button>
        </div>
      </React.Fragment>
    )
  }
}

const Wrapper = styled.div`
  &.desktop {
    display: inline-block;
    width: 100%;
    height: 400px;
    padding: 0;
    overflow: hidden;

    .scale-frame {
      width: calc(100% * 10 / 8);
      height: calc(400px * 10 / 8);
      border: 0px;
      transform: scale(0.8);
      transform-origin: 0 0;
    }
  }

  &.mobile {
    display: inline-block;
    width: 100%;
    height: 624px;
    padding: 0;
    overflow: hidden;

    .scale-frame {
      width: calc(100% * 10 / 8);
      height: calc(624px * 10 / 8);
      border: 0px;
      transform: scale(0.8);
      transform-origin: 0 0;
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/BrandWebEmbedSurveyLivePreview/index.js